import { Link } from 'react-router-dom'

import { PageBar, Content } from '../components/Layout'
import { Panel } from '../components/ui'

export function NotFound() {
  return (
    <>
      <PageBar title="Not found" />
      <Content>
        <Panel pad>
          <p className="lede">There&rsquo;s nothing at this address.</p>
          <p className="hint" style={{ marginTop: 10 }}>
            Try the <Link to="/">overview</Link>, the{' '}
            <Link to="/enquiries">enquiries</Link>, or the{' '}
            <Link to="/calendar">calendar</Link>.
          </p>
        </Panel>
      </Content>
    </>
  )
}
